import Getrewards from '@/components/Getrewards/index'
const Logspage = () => {
    const element = (<Getrewards />)
    return element
}
export default Logspage